import {
  File,
  User,
  UserCheck,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import CountUp from "react-countup";
import { ArrowRight, Calendar, ChevronUp, RotateCcw } from "react-feather";
import { Link } from "react-router-dom";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";
import { Spin } from "antd";
import moment from "moment";
import { SESSION_STORAGE } from "../../common/masterEnums";
import useDashboard from "../../controllers/useDashboard";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { all_routes } from "../../Router/all_routes";
import { decryptData } from "../../utils/encryptData";
import { USER_DETAILS } from "../../utils/encryptedConstants.";
import { currencyFormatter } from "../../utils/helperFunctions";

const Dashboard = () => {

  const user = decryptData(USER_DETAILS, SESSION_STORAGE);

  const [selectedYear, setSelectedYear] = useState(
    new Date().getFullYear().toString()
  );
  const {
    values: { storeDashboard, loading },
    refetch,
  } = useDashboard(selectedYear);

  useEffect(() => {
    refetch();
  }, [selectedYear, refetch]);

  const route = all_routes;

  const [chartOptions, setChartOptions] = useState({
    series: [],
    colors: ["#28C76F"],
    chart: {
      type: "bar",
      height: 320,
      stacked: true,
      zoom: { enabled: true },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadiusApplication: "end",
        borderRadiusWhenStacked: "all",
        columnWidth: "90%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: { min: 0, tickAmount: 5, labels: { formatter: (value) => { return currencyFormatter(value) }, } },
    xaxis: {
      categories: [],
    },
    legend: { show: false },
    fill: { opacity: 1 },
  });


  const [areaOption, setAreaOption] = useState({
    series: [],
    chart: {
      height: 273,
      type: "area",
      zoom: {
        enabled: false,
      },
    },
    colors: ["#1FC303"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
    },
    title: {
      text: "",
      align: "left",
    },
    xaxis: {
      categories: [],
    },
    yaxis: {
      min: 0,
      tickAmount: 5
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  })

  useEffect(() => {
    if (storeDashboard?.sales) {
      const months = Object.keys(storeDashboard.sales).filter(
        (key) => key !== "__typename"
      );

      const salesData = months.map((month) => {
        const salesEntry = storeDashboard.sales[month];
        return salesEntry?.sales ?? 0;
      });

      setChartOptions((prevOptions) => ({
        ...prevOptions,
        series: [
          { name: "Sales", data: salesData },
        ],
        xaxis: { categories: months.map((m) => m.charAt(0).toUpperCase() + m.slice(1).toLowerCase()) },
      }));
    }
    if (storeDashboard?.current_month) {
      setAreaOption((prev) => ({
        ...prev,
        series: [{
          name: "Sales Analysis",
          data: Object.values(storeDashboard?.current_month).map(item => item?.sale_amount ?? 0),
        }],
        xaxis: {
          categories: Object.keys(storeDashboard?.current_month).map(item => moment(item).format("DD")),
        }
      }))
    }
  }, [storeDashboard]);

  console.log("areaaaooooooptionsss", storeDashboard);


  // const [chartOptions] = useState({
  //   series: [
  //     {
  //       name: "Sales",
  //       data: [130, 210, 300, 290, 150, 50, 210, 280, 105],
  //     },
  //     {
  //       name: "Purchase",
  //       data: [-150, -90, -50, -180, -50, -70, -100, -90, -105],
  //     },
  //   ],
  //   colors: ["#28C76F", "#EA5455"],
  //   chart: {
  //     type: "bar",
  //     height: 320,
  //     stacked: true,
  //     zoom: {
  //       enabled: true,
  //     },
  //   },
  //   responsive: [
  //     {
  //       breakpoint: 280,
  //       options: {
  //         legend: {
  //           position: "bottom",
  //           offsetY: 0,
  //         },
  //       },
  //     },
  //   ],
  //   plotOptions: {
  //     bar: {
  //       horizontal: false,
  //       borderRadius: 4,
  //       borderRadiusApplication: "end", // "around" / "end"
  //       borderRadiusWhenStacked: "all", // "all"/"last"
  //       columnWidth: "20%",
  //     },
  //   },
  //   dataLabels: {
  //     enabled: false,
  //   },
  //   yaxis: {
  //     min: -200,
  //     max: 300,
  //     tickAmount: 5,
  //   },
  //   xaxis: {
  //     categories: [
  //       "Jan",
  //       "Feb",
  //       "Mar",
  //       "Apr",
  //       "May",
  //       "Jun",
  //       "Jul",
  //       "Aug",
  //       "Sep",
  //     ],
  //   },
  //   legend: { show: false },
  //   fill: {
  //     opacity: 1,
  //   },
  // });
  // const MySwal = withReactContent(Swal);
  // const showConfirmationAlert = () => {
  //   MySwal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     showCancelButton: true,
  //     confirmButtonColor: "#00ff00",
  //     confirmButtonText: "Yes, delete it!",
  //     cancelButtonColor: "#ff0000",
  //     cancelButtonText: "Cancel",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       MySwal.fire({
  //         title: "Deleted!",
  //         text: "Your file has been deleted.",
  //         className: "btn btn-success",
  //         confirmButtonText: "OK",
  //         customClass: {
  //           confirmButton: "btn btn-success",
  //         },
  //       });
  //     } else {
  //       MySwal.close();
  //     }
  //   });
  // };

  const [open, setOpen] = useState(false);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "300px" }} // Adjust height as needed
            >
              <Spin size="large" />
            </div>
          ) : (
            <>
              <div className="row">
                <div className="welcome d-lg-flex align-items-center justify-content-between">
                  <div className="d-flex flex-column justify-content-center welcome-text">
                    <h3 className="d-flex align-items-center">
                      Hi {user?.full_name}
                      <ImageWithBasePath src="assets/img/icons/hi.svg" alt="img" className="ms-2" />
                    </h3>
                    <h6 className="mt-1">here&apos;s what&apos;s happening with your store today.</h6>
                  </div>
                  {/* <div className="d-flex align-items-center">
                    <div className="position-relative daterange-wraper me-2">
                      <div className="input-groupicon calender-input">
                        <DateRangePicker initialSettings={initialSettings}>
                          <input
                            className="form-control col-4 input-range"
                            type="text"
                          // style={{ border: "none" }}
                          />
                        </DateRangePicker>
                      </div>
                      <Calendar className="feather-14" />
                    </div>

                    <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                      <Link data-bs-toggle="tooltip" data-bs-placement="top">
                        <RotateCcw className="feather feather-rotate-ccw feather-16" />
                      </Link>
                    </OverlayTrigger>

                    <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                      <Link
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        id="collapse-header"
                        className={data ? "active" : ""}
                        onClick={() => {
                          dispatch(setToogleHeader(!data));
                        }}
                      >
                        <ChevronUp />
                      </Link>
                    </OverlayTrigger>
                  </div> */}
                </div>
                {/* <div className="col-xl-3 col-sm-6 col-12 d-flex"> */}
                {/* <div className="dash-widget w-100">
                    <div className="dash-widgetimg">
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/dash1.svg"
                          alt="img"
                        />
                      </span>
                    </div>
                    <div className="dash-widgetcontent">
                      <h5>
                        <CountUp
                          start={0}
                          end={307144}
                          duration={3}
                          prefix="$"
                        />
                      </h5>
                      <h6>Total Purchase Due</h6>
                    </div>
                  </div> */}
                {/* </div> */}
                <div className="col-xl-6 col-sm-6 col-12 d-flex">
                  <div className="dash-widget dash1 w-100">
                    <div className="dash-widgetimg">
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/dash2.svg"
                          alt="img"
                        />
                      </span>
                    </div>
                    <div className="dash-widgetcontent">
                      <h5>
                        $
                        <CountUp
                          start={0}
                          end={storeDashboard?.total_sales_due}
                          duration={3} // Duration in seconds
                        />
                      </h5>
                      <h6>Total Sales Due</h6>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-sm-6 col-12 d-flex">
                  <div className="dash-widget dash2 w-100">
                    <div className="dash-widgetimg">
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/dash3.svg"
                          alt="img"
                        />
                      </span>
                    </div>
                    <div className="dash-widgetcontent">
                      <h5>
                        $
                        <CountUp
                          start={0}
                          end={storeDashboard?.total_sale_amount}
                          duration={3} // Duration in seconds
                          decimals={1}
                        />
                      </h5>
                      <h6>Total Sale Amount</h6>
                    </div>
                  </div>
                </div>
                {/* <div className="col-xl-3 col-sm-6 col-12 d-flex"> */}
                {/* <div className="dash-widget dash3 w-100">
                    <div className="dash-widgetimg">
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/dash4.svg"
                          alt="img"
                        />
                      </span>
                    </div>
                    <div className="dash-widgetcontent">
                      <h5>
                        $
                        <CountUp
                          start={0}
                          end={40000}
                          duration={3} // Duration in seconds
                        />
                      </h5>
                      <h6>Total Expense Amount</h6>
                    </div>
                  </div> */}
                {/* </div> */}
                <div className="col-xl-4 col-sm-6 col-12 d-flex">
                  <div className="dash-count">
                    <div className="dash-counts">
                      <h4>{storeDashboard?.customers}</h4>
                      <h5>Customers</h5>
                    </div>
                    <div className="dash-imgs">
                      <User />
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-sm-6 col-12 d-flex">
                  <div className="dash-count das1">
                    <div className="dash-counts">
                      <h4>{storeDashboard?.users}</h4>
                      <h5>Users</h5>
                    </div>
                    <div className="dash-imgs">
                      <UserCheck />
                    </div>
                  </div>
                </div>
                {/* <div className="col-xl-3 col-sm-6 col-12 d-flex">
                  <div className="dash-count das2">
                    <div className="dash-counts">
                      <h4>150</h4>
                      <h5>Purchase Invoice</h5>
                    </div>
                    <div className="dash-imgs">
                      <ImageWithBasePath
                        src="assets/img/icons/file-text-icon-01.svg"
                        className="img-fluid"
                        alt="icon"
                      />
                    </div>
                  </div>
                </div> */}
                <div className="col-xl-4 col-sm-6 col-12 d-flex">
                  <div className="dash-count das3">
                    <div className="dash-counts">
                      <h4>{storeDashboard?.sales_invoice}</h4>
                      <h5>Sales Invoice</h5>
                    </div>
                    <div className="dash-imgs">
                      <File />
                    </div>
                  </div>
                </div>
              </div>
              {/* Button trigger modal */}


              <div className="row sales-cards">
                <div className="col-xl-6 col-sm-12 col-12">
                  <div className="card d-flex align-items-center justify-content-between default-cover mb-4">
                    <div>
                      <h6>Weekly Earning</h6>
                      <h3>
                        $
                        <span className="counters" data-count="95000.45">
                          95000.45
                        </span>
                      </h3>
                      <p className="sales-range">
                        <span className="text-success">
                          <ChevronUp className="feather-16" />
                          48%&nbsp;
                        </span>
                        increase compare to last week
                      </p>
                    </div>
                    <ImageWithBasePath
                      src="assets/img/icons/weekly-earning.svg"
                      alt="img"
                    />
                  </div>
                </div>
                <div className="col-xl-3 col-sm-6 col-12">
                  <div className="card color-info bg-primary mb-4">
                    <ImageWithBasePath
                      src="assets/img/icons/total-sales.svg"
                      alt="img"
                    />
                    <h3>
                      {" "}
                      <CountUp end={storeDashboard?.today_sale_count} duration={4}>
                        +
                      </CountUp>
                    </h3>
                    <p>No of Total Sales (Today)</p>
                    {/* <OverlayTrigger placement="top" overlay={renderRefreshTooltip}> */}
                    <Link data-bs-toggle="tooltip" className="feather-dashboard">
                      <RotateCcw className="feather-16" />
                    </Link>
                    {/* </OverlayTrigger> */}
                  </div>
                </div>
                <div className="col-xl-3 col-sm-6 col-12">
                  <div className="card color-info bg-secondary mb-4">
                    <ImageWithBasePath
                      src="assets/img/icons/purchased-earnings.svg"
                      alt="img"
                    />
                    <h3>
                      <CountUp end={storeDashboard?.today_sale_amount} duration={4}>
                        +
                      </CountUp>
                    </h3>
                    <p>Amount of Total Sales (Today)</p>
                    {/* <OverlayTrigger placement="top" overlay={}> */}
                    <Link data-bs-toggle="tooltip" data-bs-placement="top" className="feather-dashboard">
                      <RotateCcw className="feather-16" />
                    </Link>
                    {/* </OverlayTrigger> */}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-xl-7 col-sm-12 col-12 d-flex">
                  <div className="card flex-fill">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h5 className="card-title mb-0">Yearly Sales Analysis</h5>
                      <div className="graph-sets">
                        <ul className="mb-0">
                          <li>
                            <span>Sales</span>
                          </li>
                        </ul>
                        <div className="dropdown dropdown-wraper">
                          <button
                            className="btn btn-light btn-sm dropdown-toggle"
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              setOpen(!open);
                            }}
                          >
                            {selectedYear}
                          </button>
                          {open && (
                            <ul className="dropdown-menu show">
                              <li>
                                <Link
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedYear("2025"); // Update year
                                    setOpen(false); // Close dropdown
                                  }}
                                  to="#"
                                  className="dropdown-item"
                                >
                                  2025
                                </Link>
                              </li>
                              <li>
                                <Link
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedYear("2024"); // Update year
                                    setOpen(false); // Close dropdown
                                  }}
                                  to="#"
                                  className="dropdown-item"
                                >
                                  2024
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div id="sales_charts" />
                      <Chart
                        options={chartOptions}
                        series={chartOptions.series}
                        type="bar"
                        height={320}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-xl-5 col-sm-12 col-12 d-flex">
                  <div className="card flex-fill default-cover mb-4">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h4 className="card-title mb-0">Top Customers</h4>
                      <div className="view-all-link">
                        <Link
                          to={route.productlist}
                          className="view-all d-flex align-items-center"
                        >
                          View All
                          <span className="ps-2 d-flex align-items-center">
                            <ArrowRight className="feather-16" />
                          </span>
                        </Link>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive dataview">
                        <table className="table dashboard-recent-products">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Customer Name</th>
                              <th>Representative Name</th>
                              <th>Sales Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {storeDashboard?.top_customers?.length > 0 ? (
                              storeDashboard?.top_customers?.map(
                                (item, index) => (
                                  <tr key={item.customer_id}>
                                    <td>{index + 1}</td>
                                    <td className="productimgname">
                                      <Link to={route.productlist}>
                                        {item?.customer?.full_name}
                                      </Link>
                                    </td>
                                    <td>{item?.customer?.user?.full_name}</td>
                                    <td>{currencyFormatter(item?.total_spent)}</td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td colSpan="3" className="text-center">
                                  No products available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-lg-12 col-sm-12 col-12">
                  <div className="card flex-fill default-cover">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h5 className="card-title mb-0">Monthly Sales Analytics</h5>
                      <div className="graph-sets">
                        <div className="dropdown dropdown-wraper">
                          <button
                            className="btn btn-white btn-sm dropdown-toggle d-flex align-items-center"
                            type="button"
                            id="dropdown-sales"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <Calendar className="feather-14" />
                            2023
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdown-sales"
                          >
                            <li>
                              <Link to="#" className="dropdown-item">
                                2023
                              </Link>
                            </li>
                            <li>
                              <Link to="#" className="dropdown-item">
                                2022
                              </Link>
                            </li>
                            <li>
                              <Link to="#" className="dropdown-item">
                                2021
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div id="sales-analysis" className="chart-set" />
                      <Chart
                        options={areaOption}
                        series={areaOption.series}
                        type="area"
                        height={273}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Expired Products</h4>
                </div>
                <div className="card-body">
                  <div className="table-responsive dataview">
                    <table className="table dashboard-expired-products">
                      <thead>
                        <tr>
                          <th className="no-sort">
                            <label className="checkboxs">
                              <input type="checkbox" id="select-all" />
                              <span className="checkmarks" />
                            </label>
                          </th>
                          <th>Product</th>
                          <th>SKU</th>
                          <th>Manufactured Date</th>
                          <th>Expired Date</th>
                          <th className="no-sort">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <label className="checkboxs">
                              <input type="checkbox" />
                              <span className="checkmarks" />
                            </label>
                          </td>
                          <td>
                            <div className="productimgname">
                              <Link to="#" className="product-img stock-img">
                                <ImageWithBasePath
                                  src="assets/img/products/expire-product-01.png"
                                  alt="product"
                                />
                              </Link>
                              <Link to="#">Red Premium Handy </Link>
                            </div>
                          </td>
                          <td>
                            <Link to="#">PT006</Link>
                          </td>
                          <td>17 Jan 2023</td>
                          <td>29 Mar 2023</td>
                          <td className="action-table-data">
                            <div className="edit-delete-action">
                              <Link className="me-2 p-2" to="#">
                                <i
                                  data-feather="edit"
                                  className="feather-edit"
                                />
                              </Link>
                              <Link
                                className=" confirm-text p-2"
                                to="#"
                                onClick={showConfirmationAlert}
                              >
                                <i
                                  data-feather="trash-2"
                                  className="feather-trash-2"
                                />
                              </Link>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label className="checkboxs">
                              <input type="checkbox" />
                              <span className="checkmarks" />
                            </label>
                          </td>
                          <td>
                            <div className="productimgname">
                              <Link to="#" className="product-img stock-img">
                                <ImageWithBasePath
                                  src="assets/img/products/expire-product-02.png"
                                  alt="product"
                                />
                              </Link>
                              <Link to="#">Iphone 14 Pro</Link>
                            </div>
                          </td>
                          <td>
                            <Link to="#">PT007</Link>
                          </td>
                          <td>22 Feb 2023</td>
                          <td>04 Apr 2023</td>
                          <td className="action-table-data">
                            <div className="edit-delete-action">
                              <Link className="me-2 p-2" to="#">
                                <i
                                  data-feather="edit"
                                  className="feather-edit"
                                />
                              </Link>
                              <Link
                                className="confirm-text p-2"
                                to="#"
                                onClick={showConfirmationAlert}
                              >
                                <i
                                  data-feather="trash-2"
                                  className="feather-trash-2"
                                />
                              </Link>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label className="checkboxs">
                              <input type="checkbox" />
                              <span className="checkmarks" />
                            </label>
                          </td>
                          <td>
                            <div className="productimgname">
                              <Link to="#" className="product-img stock-img">
                                <ImageWithBasePath
                                  src="assets/img/products/expire-product-03.png"
                                  alt="product"
                                />
                              </Link>
                              <Link to="#">Black Slim 200 </Link>
                            </div>
                          </td>
                          <td>
                            <Link to="#">PT008</Link>
                          </td>
                          <td>18 Mar 2023</td>
                          <td>13 May 2023</td>
                          <td className="action-table-data">
                            <div className="edit-delete-action">
                              <Link className="me-2 p-2" to="#">
                                <i
                                  data-feather="edit"
                                  className="feather-edit"
                                />
                              </Link>
                              <Link
                                className=" confirm-text p-2"
                                to="#"
                                onClick={showConfirmationAlert}
                              >
                                <i
                                  data-feather="trash-2"
                                  className="feather-trash-2"
                                />
                              </Link>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label className="checkboxs">
                              <input type="checkbox" />
                              <span className="checkmarks" />
                            </label>
                          </td>
                          <td>
                            <div className="productimgname">
                              <Link to="#" className="product-img stock-img">
                                <ImageWithBasePath
                                  src="assets/img/products/expire-product-04.png"
                                  alt="product"
                                />
                              </Link>
                              <Link to="#">Woodcraft Sandal</Link>
                            </div>
                          </td>
                          <td>
                            <Link to="#">PT009</Link>
                          </td>
                          <td>29 Mar 2023</td>
                          <td>27 May 2023</td>
                          <td className="action-table-data">
                            <div className="edit-delete-action">
                              <Link className="me-2 p-2" to="#">
                                <i
                                  data-feather="edit"
                                  className="feather-edit"
                                />
                              </Link>
                              <Link
                                className=" confirm-text p-2"
                                to="#"
                                onClick={showConfirmationAlert}
                              >
                                <i
                                  data-feather="trash-2"
                                  className="feather-trash-2"
                                />
                              </Link>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label className="checkboxs">
                              <input type="checkbox" />
                              <span className="checkmarks" />
                            </label>
                          </td>
                          <td>
                            <div className="productimgname">
                              <Link to="#" className="product-img stock-img">
                                <ImageWithBasePath
                                  src="assets/img/products/stock-img-03.png"
                                  alt="product"
                                />
                              </Link>
                              <Link to="#">Apple Series 5 Watch </Link>
                            </div>
                          </td>
                          <td>
                            <Link to="#">PT010</Link>
                          </td>
                          <td>24 Mar 2023</td>
                          <td>26 May 2023</td>
                          <td className="action-table-data">
                            <div className="edit-delete-action">
                              <Link
                                className="me-2 p-2"
                                to="#"
                                data-bs-toggle="modal"
                                data-bs-target="#edit-units"
                              >
                                <i
                                  data-feather="edit"
                                  className="feather-edit"
                                />
                              </Link>
                              <Link
                                className=" confirm-text p-2"
                                to="#"
                                onClick={showConfirmationAlert}
                              >
                                <i
                                  data-feather="trash-2"
                                  className="feather-trash-2"
                                />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div> */}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
